<template>
    <clients-section title="They Chose Us|Ils nous ont choisis">
        <client-card src="img/clients-color/entertainment/amphiteatre-cogeco.png" bg>
            Amphitéatre Cogeco
        </client-card>
        <client-card src="img/clients-color/entertainment/place-des-arts.png" bg>
            Place des Arts
        </client-card>
        <client-card src="img/clients-color/entertainment/musee-grevin.png">
            Musée Grévin Montréal
        </client-card>
        <client-card src="img/clients-color/entertainment/parc-drummondville.png">
            Parc Woodyatt & St-Frédéric
        </client-card>
        <client-card src="img/clients-color/entertainment/complexe-sportif-claude-robillard.png" bg>
            Complexe Sportif Claude-Robillard
        </client-card>
        <client-card src="img/clients-color/entertainment/clip-n-climb.png">
            Clip'n Climb
        </client-card>
    </clients-section>
</template>

<script>

import ClientCard from "@/components/client-card.vue";
import ClientsSection from "@/components/clients-section.vue";
export default {
    name: `wifi-entertainment-client-card`,
    components: {ClientCard, ClientsSection},
    data() {
        return {
            altPrefix: this.tr(`Arts and Entertainment client guest wifi|Client arts et divertissement wifi social`)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
